'use strict'

import React from 'react'
import { Link } from 'react-router'

var qs = require('qs');

require('styles/Single.less')

let config = require('config');
let backArrow   = require('../images/back_arrow.svg')
let backArrowOv = require('../images/back_arrow_over.svg')

var local = ""
var currentId = ""
var lastTitle = ""

class Single extends React.Component {
  constructor(props)
  {
    super(props)
    this.state = {
    }
  }
  componentWillMount()
  {
  }
  componentDidMount()
  {
    document.getElementsByTagName('body')[0].id = "single"
    const { actions, data, params, location } = this.props;
    currentId = params.slug

    if (location.search) {
      var url = location.search.split("?")[1]
      var obj = qs.parse(url);
      if (obj["draftKey"]) {
        actions.getSingleById(currentId, obj["draftKey"])
      } else {
        actions.getSingleById(currentId)
      }
    } else {
      actions.getSingleById(currentId)
    }
    if (location.state) {
      actions.saveLocal(currentId, location.state.updateAt)
    } else {
      actions.saveLocal(currentId, null)
    }
    local = actions.loadLocal().local
  }
  componentWillUnmount()
  {
    const { actions, data, params } = this.props;
  }
  componentDidUpdate() {
    const { actions, data, params, location } = this.props;
    if (params.slug != currentId) {
      currentId = params.slug
      actions.getSingleById(currentId)
      actions.saveLocal(currentId, location.state.updateAt)
      local = actions.loadLocal().local
    }
  }
  hasLocal(id, updatedAt) {
    for(var i = 0; i < local.length; i++) {
      if (id + "___" + updatedAt == local[i]) {
        return "visited"
      }
    }
    return ""
  }
  renderHtml(src) {
    return src
  }
  setHead(post) {
    var postTitle = post.title + "｜" + config.default.SITE_NAME
    document.title = postTitle

    if (lastTitle != postTitle) {
      const dataLayer = window.dataLayer || []
      dataLayer.push({
          'VirtualPagePath': location.pathname + location.hash,
          'VirtualPageTitle': postTitle,
          'event':'trackVirtualPageView'
      });
    }

    lastTitle = postTitle

    var meta = document.head.children;
    var metaLen = meta.length;
    for(var i = 0; i < metaLen; i++){
      var name = meta[i].getAttribute("name");
      if(name === "description"){
        if (post.excerpt) {
          meta[i].setAttribute("content", post.excerpt.replace(/\r?\n/g, "").replace("<br>", ""));
        } else {
          meta[i].setAttribute("content", "We Are ALL Born Creative. UNIVERSITY of CREATIVITY is a learning platform that cultivates human creativity as the capital for remodeling our future.");
        }
      }
      var prop = meta[i].getAttribute("property");
      if(prop === "og:description"){
        if (post.excerpt) {
          meta[i].setAttribute("content", post.excerpt.replace(/\r?\n/g, "").replace("<br>", ""));
        } else {
          meta[i].setAttribute("content", "We Are ALL Born Creative. UNIVERSITY of CREATIVITY is a learning platform that cultivates human creativity as the capital for remodeling our future.");
        }
      }
      if(prop === "og:title"){
        meta[i].setAttribute("content", post.title + " | " + config.default.SITE_NAME);
      }
      if(prop === "og:url"){
        meta[i].setAttribute("content", "https://uoc.world/postcoronaprototype/#/" + post.id + "/");
      }
      if(prop === "og:image"){
        if (post.image) {
          meta[i].setAttribute("content", post.image.url);
        } else {
          meta[i].setAttribute("content", "https://uoc.world/postcoronaprototype/assets/ogimage.jpg");
        }
      }
    }
  }
  render() {
    const { actions, data } = this.props;
    var self  = this
    var posts = data.posts;
    var post  = data.singlePost;
    if (post) {
      this.setHead(post)
    }
    return (
      <div className="single_inner">
        { post ?
          <div className="post">
              <div className="single_header">
                { post.image ?
                  <div className="single_header_main_image">
                    <img src={ post.image.url } alt={ post.title } />
                  </div>
                : null }
                <div className="single_header_title">
                  <div className="back">
                    <Link to={ "/" }>
                      <img className="def" src={ backArrow } />
                      <img className="ov" src={ backArrowOv } />
                    </Link>
                  </div>
                  <div className="title_inner">
                    <h1>{ post.title }</h1>
                    <div className="artist" dangerouslySetInnerHTML={{ __html:post.artist }} />
                  </div>
                </div>
              </div>
              <div className="single_body">
                <div className="single_body_left">
                  <div className="single_body_excerpt" dangerouslySetInnerHTML={{ __html:post.excerpt }} />
                  <div className="single_body_content" dangerouslySetInnerHTML={{ __html:this.renderHtml(post.content) }} />
                  { post.src ?
                    <div className="single_body_src" dangerouslySetInnerHTML={{ __html:post.src }} />
                  : null }
                </div>
                <div className="single_body_right">
                  { posts ?
                    <div className="posts">
                      { posts.contents.map(function(post, i) {
                        if (post.islink) {
                          return (
                            <div key={i} className={ "post " + self.hasLocal(post.id, post.updatedAt) }><Link className={ currentId == post.id ? "current":"" } to={{pathname:"/" + post.id + "/", state:{updateAt:post.updatedAt}}}>{ post.tag }</Link></div>
                          )
                        } else {
                          return (
                            <div key={i} className={ "post" }>{ post.tag }</div>
                          )
                        }
                      }) }
                      ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ ・ and more. What's your prototype?
                    </div>
                  : null }
                </div>
              </div>
          </div>
        : null }
        { post ?
          <footer>
            <div className="footer_inner">
              <div className="footer_link"><a href="https://uoc.world/" target="_blank">UNIVERSITY of CREATIVITY</a></div>
              <div className="footer_copy">&copy;UNIVERSITY of CREATIVITY. All Rights Reserved.</div>
            </div>
          </footer>
        : null }
      </div>
    )
  }
}

Single.displayName = 'Single'
Single.propTypes = {}
Single.defaultProps = {}

export default Single



// WEBPACK FOOTER //
// ./src/components/SingleComponent.js